import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanMatch, Route, UrlSegment } from '@angular/router';
import { AuthService } from './auth-service.service';
import { AppComponent } from './app.component';

@Injectable()
export class AuthGuardService implements CanActivate, CanMatch {

  constructor(public auth: AuthService, public router: Router) { }

  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {
  //     if (!this.auth.isAuthenticated()) {
  //         this.router.navigate(['/login']);
  //         return false;
  //     }
  //     return true;
  // }

  // =====================================================
  // CAN ACTIVATE
  // =====================================================

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    return this.checkAuthentication(state.url);
  }

  // =====================================================
  // CAN MATCH
  // =====================================================

  canMatch(
    route: Route,
    segments: UrlSegment[]
  ): boolean {

    const url = '/' + segments
      .map(segment => segment.path)
      .join('/');

    return this.checkAuthentication(url);
  }

  // =====================================================
  // AUTHENTICATION CHECK
  // =====================================================

  private checkAuthentication(
    returnUrl: string
  ): boolean {

    if (this.auth.isAuthenticated()) {
      return true;
    }

    this.router.navigate(
      ['/login']
    );

    return false;
  }

}
